import { Link } from "react-router-dom";
import { BsMap } from "react-icons/bs";
import { GoDot } from "react-icons/go";
import { GiPriceTag, GiElevator } from "react-icons/gi";
import { IoIosResize } from "react-icons/io";
import { MdOutlineBed, MdOutlineBathtub } from "react-icons/md";
import moment from "moment";
import "moment/locale/es";
import "./ContactAdCard.scss";

const ContactAdCard = ({ ad }) => {
  const formatCurrency = (value) => {
    return (
      Math.round(value)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " €"
    );
  };

  const formatSurface = (value) => {
    return (
      <>
        {value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} m<sup>2</sup>
      </>
    );
  };

  const noData = <span className="ContactAdCard__no-data">No hay datos</span>;

  return (
    <div className="ContactAdCard">
      <div className="ContactAdCard__image-container">
        {ad.images?.main ? (
          <img src={ad.images.main} alt={ad.title || "Anuncio"} />
        ) : (
          <div className="ContactAdCard__no-image">Sin imagen</div>
        )}
        <div
          className={`ContactAdCard__status ContactAdCard__status--${
            ad.adStatus?.replace(/\s+/g, "-").toLowerCase() || "default"
          }`}
        >
          {ad.adStatus || "Sin estado"}
        </div>
      </div>

      <div className="ContactAdCard__main-container">
        {/* HEADER: Título y Ubicación */}
        <div className="ContactAdCard__header">
          <div className="ContactAdCard__header-top">
            <h4>{ad.title || "Sin título"}</h4>
            <span className="ContactAdCard__reference">
              {ad.adReference || "Ref: ---"}
            </span>
          </div>

          <div className="ContactAdCard__location">
            <BsMap className="ContactAdCard__icon--loc" />
            {ad.adDirection?.city ? (
              <span>{ad.adDirection.city}</span>
            ) : (
              <span>Ciudad no disponible</span>
            )}
            {ad.zone?.[0]?.name && (
              <>
                <GoDot className="ContactAdCard__icon--dot" />
                <span>{ad.zone[0].name}</span>
              </>
            )}
          </div>
        </div>

        {/* BODY: Info rápida */}
        <div className="ContactAdCard__body">
          {/* SECCIÓN PRECIO */}
          <div className="ContactAdCard__section">
            <h4 className="ContactAdCard__section-title">
              <GiPriceTag className="ContactAdCard__icon--main" />
              <b>Precio</b>
            </h4>
            <div className="ContactAdCard__price-container">
              {ad.sale?.saleValue > 0 && (
                <p className="ContactAdCard__price ContactAdCard__price--sale">
                  <small>Venta:</small> {formatCurrency(ad.sale.saleValue)}
                </p>
              )}
              {ad.rent?.rentValue > 0 && (
                <p className="ContactAdCard__price ContactAdCard__price--rent">
                  <small>Alquiler:</small> {formatCurrency(ad.rent.rentValue)}
                </p>
              )}
              {!ad.sale?.saleValue && !ad.rent?.rentValue && noData}
            </div>
          </div>

          {/* SECCIÓN SUPERFICIE */}
          <div className="ContactAdCard__section">
            <h4 className="ContactAdCard__section-title">
              <IoIosResize className="ContactAdCard__icon--main" />
              <b>Superficie</b>
            </h4>
            <div className="ContactAdCard__surface-container">
              {ad.buildSurface > 0 || ad.plotSurface > 0 ? (
                <>
                  {ad.buildSurface > 0 && (
                    <p className="ContactAdCard__surface-item">
                      <small>Construida:</small>{" "}
                      {formatSurface(ad.buildSurface)}
                    </p>
                  )}
                  {ad.plotSurface > 0 && (
                    <p className="ContactAdCard__surface-item">
                      <small>Parcela:</small> {formatSurface(ad.plotSurface)}
                    </p>
                  )}
                </>
              ) : (
                noData
              )}
            </div>
          </div>
        </div>
        <div className="ContactAdCard__body">
          {/* CARACTERÍSTICAS */}
          <div className="ContactAdCard__features">
            {ad.quality?.bedrooms > 0 ||
            ad.quality?.bathrooms > 0 ||
            ad.quality?.others?.lift ? (
              <>
                {ad.quality?.bedrooms > 0 && (
                  <div className="ContactAdCard__feature-item">
                    <MdOutlineBed /> <span>{ad.quality.bedrooms}</span>
                  </div>
                )}
                {ad.quality?.bathrooms > 0 && (
                  <div className="ContactAdCard__feature-item">
                    <MdOutlineBathtub /> <span>{ad.quality.bathrooms}</span>
                  </div>
                )}
                {ad.quality?.others?.lift && (
                  <div className="ContactAdCard__feature-item">
                    <GiElevator /> <span>Ascensor</span>
                  </div>
                )}
              </>
            ) : (
              noData
            )}
          </div>
        </div>
      </div>

      {/* CTA y Fecha */}
      <div className="ContactAdCard__footer">
        <span className="ContactAdCard__date">
          {ad.updatedAt
            ? `Actualizado ${moment(ad.updatedAt).fromNow()}`
            : "Fecha no disponible"}
        </span>
        <Link className="ContactAdCard__button" to={`/anuncios/${ad._id}`}>
          Ver Anuncio
        </Link>
      </div>
    </div>
  );
};

export default ContactAdCard;
